import { Routes } from 'app/services/routeService/routeService'
import { useIsPlaceRestricted } from 'commons/useIsPlaceRestricted'
import * as R from 'ramda'
import { useCallback, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { useIsAuthorized } from './authHooks'
import { useIsRootAdmin, useUserProfile } from 'commons/useUserProfile'

const planAndBillingURL = (path) => {
  return R.includes(path, [
    Routes.billingOverview(),
    Routes.usageSummary(),
    Routes.usageHistory(),
    Routes.aiUsageLog(),
  ])
    ? path
    : Routes.billingOverview()
}

const excludedURL = [Routes.billingchangePlan()]

const AppRestrictAccessControl = ({ children, routes, history, location }) => {
  const isPlaceRestricted = useIsPlaceRestricted()
  const pathName = R.prop('pathname', location)
  const isAuthorized = useIsAuthorized()
  const isRootAdmin = useIsRootAdmin()
  const userData = useUserProfile()

  const pushPathname = useCallback(
    (input) => {
      history.push(input)
    },
    [history],
  )

  useEffect(() => {
    if (
      isPlaceRestricted &&
      isAuthorized &&
      isRootAdmin(userData.id) &&
      R.o(R.not, R.includes(pathName))(excludedURL)
    ) {
      pushPathname({
        pathname: planAndBillingURL(pathName),
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPlaceRestricted, pushPathname, pathName])

  return children
}

export default withRouter(AppRestrictAccessControl)
